/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProfileSettingsRequest
 */
export interface UpdateProfileSettingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProfileSettingsRequest
     */
    sendPromotionalSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProfileSettingsRequest
     */
    sendTransactionalSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProfileSettingsRequest
     */
    sendCommunicationalSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProfileSettingsRequest
     */
    allowAutoPayment: boolean;
}

/**
 * Check if a given object implements the UpdateProfileSettingsRequest interface.
 */
export function instanceOfUpdateProfileSettingsRequest(value: object): value is UpdateProfileSettingsRequest {
    if (!('sendPromotionalSms' in value) || value['sendPromotionalSms'] === undefined) return false;
    if (!('sendTransactionalSms' in value) || value['sendTransactionalSms'] === undefined) return false;
    if (!('sendCommunicationalSms' in value) || value['sendCommunicationalSms'] === undefined) return false;
    if (!('allowAutoPayment' in value) || value['allowAutoPayment'] === undefined) return false;
    return true;
}

export function UpdateProfileSettingsRequestFromJSON(json: any): UpdateProfileSettingsRequest {
    return UpdateProfileSettingsRequestFromJSONTyped(json, false);
}

export function UpdateProfileSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfileSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sendPromotionalSms': json['sendPromotionalSms'],
        'sendTransactionalSms': json['sendTransactionalSms'],
        'sendCommunicationalSms': json['sendCommunicationalSms'],
        'allowAutoPayment': json['allowAutoPayment'],
    };
}

export function UpdateProfileSettingsRequestToJSON(json: any): UpdateProfileSettingsRequest {
    return UpdateProfileSettingsRequestToJSONTyped(json, false);
}

export function UpdateProfileSettingsRequestToJSONTyped(value?: UpdateProfileSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sendPromotionalSms': value['sendPromotionalSms'],
        'sendTransactionalSms': value['sendTransactionalSms'],
        'sendCommunicationalSms': value['sendCommunicationalSms'],
        'allowAutoPayment': value['allowAutoPayment'],
    };
}

